<lib-modal-layout [title]="'Archive Submission'" [subtitle]="agencyName + ' - ' + submissionNumber">
  <div class="text-center">
    <h3 class="app">Are you sure?</h3>
    <p class="large mt-5">Archiving will cause this submission to no longer appear in your submissions grid.</p>
    <p class="medium bold mt-5">Type "ARCHIVE" in the field below to confirm.</p>
  </div>
  <form>
    <lib-form-text
      [formControl]="confirm"
      [label]="'Confirm Archive'"
    ></lib-form-text>
    <lib-button
      btnPrimary
      [cssType]="'btn-primary'"
      [icon]="'rightarrow'"
      [text]="'Submit'"
      [type]="'submit'"
      [disabled]="confirm.value.toLowerCase() !== 'archive'"
      (click)="onSubmit()"
    ></lib-button>
  </form>
</lib-modal-layout>